import React from "react";
import type { IconType } from "react-icons";
import { useGlobalState } from "../../GlobalState";
import {
    FaRegClock,
    FaRegFilePdf,
    FaRegCircle,
    FaCircle,
    FaArrowLeft,
    FaArrowRight,
    FaChevronCircleRight,
    FaPlayCircle,
    FaRegStar,
    FaStar,
    FaMap,
    FaUnlock,
    FaVideo,
    FaPen,
    FaArrowDown,
    FaFileAlt,
    FaDiscord,
    FaHome,
    FaBook,
    FaCode, FaUserGraduate, FaServer,
} from "react-icons/fa";
import { HiOutlineExternalLink } from "react-icons/hi";
import {
    IoChevronBack,
    IoChevronDown,
    IoChevronForward,
    IoDocumentTextSharp,
    IoPeopleSharp,
    IoVideocamOutline
} from "react-icons/io5";
import {IoIosCheckmarkCircle, IoIosDocument, IoIosMore, IoIosPerson, IoIosPhonePortrait, IoMdCheckmark} from "react-icons/io";
import { GoPencil } from "react-icons/go";
import {FaListUl, FaUserGroup} from "react-icons/fa6";
import { CiCalendar } from "react-icons/ci";
import { GiHamburgerMenu } from "react-icons/gi";
import { RiAccountBoxFill } from "react-icons/ri";
import {LiaChalkboardTeacherSolid} from "react-icons/lia";
import {IoClose, IoAddCircle, IoRefreshCircleSharp} from "react-icons/io5";
import {LuMonitor, LuSparkle, LuSparkles} from "react-icons/lu";
import {MdNotificationsActive} from "react-icons/md";
import { IoSearch } from "react-icons/io5";
import { FaGamepad, FaCalculator } from "react-icons/fa";
import {BsBuildingsFill} from "react-icons/bs";
import { CiCircleInfo } from "react-icons/ci";
import { FaSearch, FaCloudUploadAlt, FaLightbulb, FaHandshake, FaEye } from "react-icons/fa";

export const ICONS: Record<string, IconType> = {
    CLOCK: FaRegClock,
    PDF: FaRegFilePdf,
    LESSONS: FaListUl,
    SOLID_CIRCLE: FaCircle,
    HOLLOW_CIRCLE: FaRegCircle,
    CHECKMARK_CIRCLE: IoIosCheckmarkCircle,
    CHECKMARK: IoMdCheckmark,
    MORE_INFO: CiCircleInfo,
    PHONE_PORTRAIT: IoIosPhonePortrait,
    PREMIUM: FaStar,
    RATING_STAR: FaStar,
    LEFT_ARROW: FaArrowLeft,
    RIGHT_ARROW: FaArrowRight,
    CALENDAR: CiCalendar,
    HAMBURGER: GiHamburgerMenu,
    RIGHT_ARROW_CIRCLE: FaChevronCircleRight,
    PLAY_CIRCLE: FaPlayCircle,
    DISCORD: FaDiscord,
    ACCOUNT: RiAccountBoxFill,
    ADD_CIRCLE: IoAddCircle,
    ARROW_DOWN: FaArrowDown,
    CHALKBOARD_TEACHER: LiaChalkboardTeacherSolid,
    VIDEO: IoVideocamOutline,
    DOCUMENT: IoIosDocument,
    SPARKLE: LuSparkle,
    SPARKLES: LuSparkles,
    PEN: GoPencil,
    CLOSE: IoClose,
    MAP: FaMap,
    UNLOCK: FaUnlock,
    NOTIFICATION: MdNotificationsActive,
    FILE: FaFileAlt,
    REFRESH: IoRefreshCircleSharp,
    CHEVRON_LEFT: IoChevronBack,
    CHEVRON_DOWN: IoChevronDown,
    CHEVRON_RIGHT: IoChevronForward,
    MORE: IoIosMore,
    HOME: FaHome,
    REFERENCES_SEARCH: IoSearch,
    GAMES: FaGamepad,
    CHALLENGES: FaCalculator,
    BOOK: FaBook,
    CODE: FaCode,
    EXTERNAL_LINK: HiOutlineExternalLink,
    MONITOR: LuMonitor,
    SELF: IoIosPerson,
    COMPANY: BsBuildingsFill,
    GRADUATE: FaUserGraduate,
    SERVER: FaServer,
    PEOPLE: IoPeopleSharp,
    RESUME: IoDocumentTextSharp,
    SEARCH: FaSearch,
    UPLOAD: FaCloudUploadAlt,
    LIGHTBULB: FaLightbulb,
    HANDSHAKE: FaHandshake,
    EYE: FaEye
}

interface BCIconProps {
    icon: IconType;
    className?: string;
    id?: string;
    onClick?: () => void;
    [key: string]: any;
}

export const BCIcon: React.FC<BCIconProps> = ({ icon: Icon, className = "", id = "", onClick, ...rest }) => {
    if (!Icon) return null;
    // @ts-ignore
    return <Icon className={className} id={id} onClick={onClick} {...rest} />;
};

/**
 * Returns an Icon component from a string name (e.g., "CLOCK").
 * If not found, returns undefined.
 */
export const getIconFromString = (name: string): IconType => {
    if (ICONS[name.toUpperCase()]) {
        return ICONS[name.toUpperCase()]
    } else {
        return ICONS.ACCOUNT
    }
};

interface PremiumIndicatorProps {
    isPremium: boolean;
    className?: string;
}

export const PremiumIndicator: React.FC<PremiumIndicatorProps> = ({ isPremium, className = "" }) => {
    const { isAuthenticated, isPremium: userIsPremium } = useGlobalState();
    
    // Hide premium indicator if:
    // 1. Content is not premium, OR
    // 2. User is not authenticated, OR  
    // 3. User is authenticated and has premium access
    if (!isPremium || !isAuthenticated || userIsPremium) return null;
    
    return (
        <div className={`premium-indicator ${className}`}>
            <span className="premium-text">Premium</span>
            <BCIcon 
                icon={ICONS.PREMIUM} 
                className="premium-star-icon"
            />
        </div>
    );
};